import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, Icon, toast } from '@livable/saas-react-components';
import { Button, Typography, Chip, FormGroup, FormControlLabel, Switch } from '@mui/material';
import useStyles from './styles';
import { useStore } from 'src/stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
export const ResendStatementModalContent = observer(_ref => {
  var _store$homeDashboardS;
  let residencyId = _ref.residencyId,
    userProfileData = _ref.userProfileData,
    handleModalClose = _ref.handleModalClose,
    resendStatementId = _ref.resendStatementId,
    resendStatementFileId = _ref.resendStatementFileId;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    paperStatement = _useState4[0],
    setPaperStatement = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    electronicStatement = _useState6[0],
    setElectronicStatement = _useState6[1];
  const handleSubmit = async () => {
    setIsLoading(true);
    let sendPaperStatementResp = {
      isSuccessful: true
    };
    let resendPaperStatementResp = {
      isSuccessful: true
    };
    if (electronicStatement) {
      sendPaperStatementResp = await store.statement.sendPaperStatementAsync.run({
        paperStatementId: resendStatementId
      });
    }
    if (paperStatement) {
      resendPaperStatementResp = await store.residencies.resendPaperStatementAsync.run({
        residencyId: residencyId,
        paperFileId: resendStatementFileId
      });
    }
    if (sendPaperStatementResp.isSuccessful && resendPaperStatementResp.isSuccessful) {
      toast('success', {
        body: ['Successfully sent']
      });
    }
    setIsLoading(false);
    handleModalClose();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, !(store.company.companyFeatureStore.disablePaperStatementFee || (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS !== void 0 && (_store$homeDashboardS = _store$homeDashboardS.companyFeatureSet) !== null && _store$homeDashboardS !== void 0 && _store$homeDashboardS.disablePaperStatementFee) && /*#__PURE__*/React.createElement(Chip, {
    label: t('resident_account.you_will_be_charged'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "info"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, null),
    checked: electronicStatement,
    disabled: !userProfileData.newEmail && !userProfileData.email,
    onChange: () => {
      setElectronicStatement(!electronicStatement);
    },
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      className: !userProfileData.newEmail && !userProfileData.email ? classes.disabledLabel : ''
    }, t('resident_account.electronic_statement'), !userProfileData.newEmail && !userProfileData.email && /*#__PURE__*/React.createElement("span", null, " (unavailable, no email address)"))
  })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, null),
    checked: paperStatement,
    onChange: () => {
      setPaperStatement(!paperStatement);
    },
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, t('resident_account.paper_statement'))
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: handleSubmit,
    disabled: !(electronicStatement || paperStatement),
    'custom-attribute': '811-resident-profile-page-resend-statement-modal'
  }, t('general.send'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }));
});